/** Эндпоинт на получение данных плитки тарифа  */
export const API_URL = '/api/v1/constructors/get-tariff-card/';
